module.exports = __webpack_public_path__ + "img/MoonBalloon.b92fe803.svg";